import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

const DOC = gql`
  query Tenants($ids: [ID!], $quantity: Int, $cursor: String) {
    tenants(ids: $ids, quantity: $quantity, cursor: $cursor) {
      items {
        id
        code
        alias
        name
        color
        createdBy
        monthlyCreditLimit
      }
      nextCursor
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.TenantsQuery,
    ents.core.common.Response.For.Pagination<ents.core.admin.Tenant>,
    'tenants'
  >(
    'tenants',
    graphql.transformers.OUT.object({
      items: graphql.transformers.OUT.default(
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.object({
            alias: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
              {
                warnOnly: true,
              },
            ),
            code: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
              {
                warnOnly: true,
              },
            ),
            color: graphql.transformers.OUT.nullable(
              transformers.PASS_THROUGH,
            ),
            createdBy: transformers.PASS_THROUGH,
            monthlyCreditLimit: transformers.PASS_THROUGH,
            id: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
              {
                warnOnly: true,
              },
            ),
            name: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
              {
                warnOnly: true,
              },
            ),
          }),
          {
            onNullish: 'remove',
          },
        ),
        [],
      ),
      nextCursor: graphql.transformers.OUT.nullable(transformers.PASS_THROUGH),
    }),
  ),
  { items: [], nextCursor: undefined },
)

export const execute = graphql.createExecutor<
  graphql.schema.TenantsQuery,
  ents.core.common.Response.For.Pagination<ents.core.admin.Tenant>,
  graphql.schema.TenantsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
